import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const getAllInvoice = async(employee_id, page, pageSize) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_INVOICES+"employee_id="+employee_id+"&page="+page+"&pagesize="+pageSize, token)
  return res;
};

export const getAllInvoicebyTenant = async(tenant_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_INVOICES_BY_TENANT+tenant_id, token)
  return res;
};

export const getInvoiceDetails = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_INVOICE_DETAILS}/${id}`, token)
  return res;
};

export const addInvoice = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_INVOICE, payload, token)
  return res;
};
export const updateInvoice = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_INVOICE}/${id}`, payload, token)
  return res;
};
export const deleteInvoiceByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_INVOICE}/${id}`, {}, token)
  return res;
};

export const getAllPaySlip = async(employee_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_PAY_SLIPS+employee_id, token)
  return res;
};

export const getAllPaySlipByTenant = async(tenant_id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_PAY_SLIPS_BY_TENANT+tenant_id, token)
  return res;
};

export const getPaySlipDetails = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_PAY_SLIP_DETAILS}/${id}`, token)
  return res;
};

export const addPaySlip = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_PAY_SLIP, payload, token)
  return res;
};
export const updatePaySlip = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_PAY_SLIP}/${id}`, payload, token)
  return res;
};
export const deletePaySlipByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_PAY_SLIP}/${id}`, {}, token)
  return res;
};